import { createRoot, useState } from '@wordpress/element';

import Graph from './graph-canvas';
import { getCartogramDataFromTaxs } from './helpers';
import SVGGraph from './graph-svg';

import PostsTemplate from '../posts-template';
import { getName } from '../helpers';

function isCanvasSupported() {
	const elem = document.createElement('canvas');
	return !!(elem.getContext && elem.getContext('2d'));
}

window.addEventListener('DOMContentLoaded', () => {
	const cartograms = document.querySelectorAll(
		'.wp-block-ae-block-viz-cartogram'
	);
	for (const cartogramEl of cartograms) {
		const dataEl = cartogramEl.querySelector('.ae-cartogram-viz-data');

		if (!dataEl) return;
		const dataHTML = dataEl.innerHTML;
		// Parse JSON for the code output
		const dataJSON = JSON.parse(dataHTML);

		const domNode = cartogramEl.querySelector(
			'div[id*="ae-cartogram-viz-root"]'
		);
		const root = createRoot(domNode);

		root.render(<Cartogram dataJSON={dataJSON} />);
	}
});

const Cartogram = ({ dataJSON }) => {
	const { id } = dataJSON.attributes;
	const vizData = getCartogramDataFromTaxs(dataJSON.taxonomies);
	const [geometries, setGeometries] = useState();

	function onSelectGeometry(features) {
		if ('query' !== dataJSON.dataType) return;

		if (!features.length) {
			setGeometries([]);
			return;
		}

		const fNames = features.map((f) => getName(f));

		setGeometries(fNames);
	}
	let query;
	let matchedTaxs = [];
	matchedTaxs = Object.values(dataJSON.taxonomies)[0].filter((t) =>
		geometries?.includes(t.name)
	);
	if (matchedTaxs.length) {
		query = {
			taxQuery: {
				category: matchedTaxs?.map((t) => t.term_id),
			},
		};
	}

	const GraphComponent = isCanvasSupported() ? Graph : SVGGraph;

	return (
		<>
			<div className="viz">
				<GraphComponent
					{...{
						...dataJSON.attributes,
						data: vizData,
						onSelect: onSelectGeometry,
					}}
				/>
			</div>

			{query && (
				<PostsTemplate
					template={dataJSON.template}
					query={query}
					queryId={id}
				/>
			)}
		</>
	);
};
